// extracted by mini-css-extract-plugin
module.exports = {"settingsCloseButton":"SettingsMenu_settingsCloseButton__mdSd2","tabs":"SettingsMenu_tabs__uq0cC","tab":"SettingsMenu_tab__Pfa2A"};